import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { fromStaticDataCountriesActions } from '../actions';
import { IStaticDataCountriesResponse } from '../models/static-data-countries.model';

export const staticDataCountriesFeatureKey = 'staticDataCountries';

export interface StaticDataCountriesState {
  loadStaticDataCountries: void;
  loadStaticDataCountriesResponse: IStaticDataCountriesResponse[];
  loadStaticDataCountriesFailure: IGenericError<ErrorResponse>;
}

export const initialState: StaticDataCountriesState = {
  loadStaticDataCountries: undefined,
  loadStaticDataCountriesResponse: undefined,
  loadStaticDataCountriesFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromStaticDataCountriesActions.loadStaticDataCountries, (state, action) => ({
    ...state,
    loadStaticDataCountries: null
  })),

  on(fromStaticDataCountriesActions.loadStaticDataCountriesSuccess, (state, action) => ({
    ...state,
    loadStaticDataCountriesResponse: action.response
  })),

  on(fromStaticDataCountriesActions.loadStaticDataCountriesFailure, (state, action) => ({
    ...state,
    loadResendOtpFailure: action.error
  }))
);

export const getStaticDataCountriesResponse = (state: StaticDataCountriesState) => state.loadStaticDataCountriesResponse;
export const getStaticDataCountriesFailure = (state: StaticDataCountriesState) => state.loadStaticDataCountriesFailure;
